import { Actions, createStore } from '@bpd-library/utilities';
import { KRPANO_XML } from '@molecules/krpano/constants';
import environment from '@utilities/environment';
import { getAssetsFolder } from '@utilities/get-assets-folder';
import { buildPathWithQuery } from '@utilities/url';

export interface KrpanoStateItem {
    pano?: string;
    initialSceneId?: string;
}

export interface KrpanoState {
    [id: string]: KrpanoStateItem;
}

type KrpanoStoreAction = 'updateSelectedPano';

const initialState: KrpanoState = {};

const actions: Actions<KrpanoStoreAction, KrpanoState> = {
    updateSelectedPano: (
        state: KrpanoState,
        data: { tourId: string; pano: string; sceneId?: string },
    ) => {
        const { tourId, pano, sceneId } = data;

        state[tourId] = { pano, initialSceneId: sceneId };
        return state;
    },
};

export const krpanoStore = createStore<KrpanoState, KrpanoStoreAction>({
    initialState,
    actions,
});

export const updateSelectedPano = (tourId: string, newPano: string, sceneId?: string) => {
    // in the local environment this just forces the store update on sceneId change
    // in test, acc and prod, it is also used to correctly construct the krpano xml
    let panoPath: string;
    if (environment.isLocal) {
        panoPath = getAssetsFolder(newPano ? newPano : KRPANO_XML);
    } else {
        panoPath = newPano;
    }

    const pano = buildPathWithQuery(panoPath, {
        vrTourId: tourId,
        ...(sceneId && { sceneId }),
    });

    krpanoStore.dispatch('updateSelectedPano', { tourId, pano, sceneId });
};
